import { Button } from "components/ui/button";
import { SaveAll } from "lucide-react";
import { memo } from "react";
import StoreReturnBtn from "../store-return";
import { PageTitle } from "components/layout";
import ReprocessConciliation from "../reprocess-conciliation";

interface HeaderProps {
  codeTitle: string;
  conciliationDate: string;
  isClosed: boolean;
  isAdmin: boolean;
  isLoading: boolean;
  isSaveLoading: boolean;
  onSaveAll: () => void;
}

function HeaderInner({
  codeTitle,
  conciliationDate,
  isClosed,
  isAdmin,
  isLoading,
  isSaveLoading,
  onSaveAll,
}: HeaderProps) {
  return (
    <header className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10">
      <div className="flex flex-col gap-3">
        <StoreReturnBtn />
        <PageTitle titleSize="text-3xl" descriptionSize="text-xl" title={codeTitle ? `Conciliação de Caixas - Loja ${codeTitle}` : ""} description={codeTitle ? `Data: ${conciliationDate}` : ""} />
      </div>
      {!isClosed && (
        <div className="flex flex-wrap gap-2 items-end justify-end ">
          {isAdmin && <ReprocessConciliation />}
          <Button
            className="bg-[#2B0C1A] text-white hover:bg-[#2B0C1A]/85 flex gap-2"
            onClick={onSaveAll}
            disabled={isLoading || isSaveLoading}
          >
            <SaveAll />
            Salvar Todos
          </Button>
        </div>
      )}
    </header>
  );
}

export const Header = memo(HeaderInner);
